// export const INIT = "INIT";

export const STATIONS_API_REQUEST = "STATIONS_API_REQUEST";
export const STATIONS_API_START = "STATIONS_API_START";
export const STATIONS_API_RESULT = "STATIONS_API_RESULT";

export const SHOW_INFOWINDOW = "SHOW_INFOWINDOW";
export const UPDATE_LIST = "UPDATE_LIST;"

export const MAP_LOADED = "MAP_LOADED";

export const SET_BROWSER_LOCATION = "SET_BROWSER_LOCATION";

// export getAllWorkstations: () => dispatch({ type: GET_ALL_WORKSTATIONS })

